import styled from 'styled-components';

import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { NoSSR } from '@xing-com/crate-utils-no-ssr';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { spaceXXL } from '@xing-com/tokens';

const StyledFrame = styled.iframe`
  width: 728px;
  min-height: 90px;
  max-height: 300px;
  border: 0;
  margin: ${spaceXXL};
`;
type IframeTypes = {
  trackingParams: {
    page: string;
    sentBy: string;
  };
};

export const DisplayAdLoginLeaderboardIframeSlot: React.FC<IframeTypes> = ({
  trackingParams,
}) => {
  const { sentBy, page } = trackingParams;

  const isSmallScreen = useMatchMedia(mediaSmallOrTiny);

  if (isSmallScreen) {
    return null;
  }

  return (
    <NoSSR>
      <StyledFrame
        src={`/reklame/iframe?sentBy=${encodeURIComponent(sentBy)}&page=${encodeURIComponent(page)}`}
        title="Reklame frame"
        sandbox="allow-scripts allow-same-origin allow-popups"
        scrolling="no"
      />
    </NoSSR>
  );
};
